import { makeStyles, tokens, shorthands, GriffelStyle } from '@fluentui/react-components';

const makeStatusIndicatorStyles = (
    statusStyles: Record<string, GriffelStyle>
): GriffelStyle => {
    return {
        display: 'inline-block',
        height: tokens.spacingHorizontalXS,
        width: tokens.spacingHorizontalXS,
        marginRight: tokens.spacingHorizontalXS,
        ...shorthands.borderRadius('50%'),
        ...statusStyles,
    };
};

export const makeActiveConversationsPageStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        height: 'calc(100vh)',
        maxHeight: 'calc(100vh)',
        minHeight: 0,
        boxSizing: 'border-box',
        overflow: 'hidden',
        overflowX: 'hidden',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: 0,
        minHeight: 0,
        flex: '1 1 auto',
        overflow: 'hidden',
    },
    tableScrollContainer: {
        width: '100%',
        minWidth: 0,
        minHeight: 0,
        overflowX: 'auto',
        overflowY: 'auto',
        flex: '1 1 0',
    },
    table: {
        marginTop: tokens.spacingVerticalM,
        flexShrink: 0,
    },
    pagination: {
        flexShrink: 0,
    },
    tableRow: {
        justifyContent: 'space-between',
        height: '44px',
        minWidth: 'fit-content',
        ...shorthands.padding(0, tokens.spacingHorizontalXL),
    },
    tableSelectionCell: {
        minWidth: '25px',
        maxWidth: '25px',
    },
    statusIndicator: makeStatusIndicatorStyles({
        '&.Yes': {
            backgroundColor: tokens.colorPaletteLightGreenForeground3,
        },
        '&.No': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
    }),
    connectionStatusIndicator: makeStatusIndicatorStyles({
        '&.None': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.New': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.Established': {
            backgroundColor: tokens.colorPaletteLightGreenForeground3,
        },
        '&.Closed': {
            backgroundColor: tokens.colorPalettePlatinumBackground2,
        },
        '&.Error': {
            backgroundColor: tokens.colorPaletteRedForeground3,
        },
    }),
    status: {
        display: 'flex',
        alignItems: 'center',
    },
});